<template>
  <div>
    <!-- <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('profile') }}
    </h1> -->
    <div class="profileImg">
      <div class="userAccount">
        <div class="userAccount__image">
          <img class="user_img" src="../../assets/cutehub/imgs/dummy_account.jpeg"/>
        </div>
        <div class="userAccount__name">
          <h1 class="mobiTitle md">{{ $t("hello") }} Jacqueline</h1>
        </div>
      </div>
    </div>
    <div class="main_wrap">
      <div class="mobiSection">
        <div class="mobiSection__content">
          <div class="userProfile">
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('registered_num') }}:</label>
              <h2 class="mobiTitle md text_color">{{msisdn_cutehub}}</h2>
            </div>
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('subscription_date') }}:</label>
              <h2 class="mobiTitle md text_color">{{subscription_date_cutehub}}</h2>
            </div>  
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('next_renew_date') }}:</label>
              <h2 class="mobiTitle md text_color">{{renew_date_cutehub}}</h2>
            </div>
          </div>
          <div class="btnContainer " v-if="auth_cutehub === 'loggedin'">
            <div v-if="is_unsub_cutehub != '0'">
              <a @click="logout_cutehub(is_unsub_cutehub)" style="text-decoration:none; color: white" class="mobiBtn">{{ $t("unsubscribe") }}</a>
            </div>
            <div v-else-if="countryCode === 'fi' && gateway_code_cutehub === 'nth'">
            </div>
            <div v-else>
              <a @click="logout_cutehub(is_unsub_cutehub)" href="/logout" class="mobiBtn">{{ $t("unsubscribe") }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>  
    
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

export default {
  computed: mapGetters([
    "msisdn_cutehub",
    "renew_date_cutehub",
    "subscription_date_cutehub",
    "auth_cutehub",
    "is_unsub_cutehub",
    "countryCode",
    "gateway_code_cutehub",
  ]),
  methods: {
    ...mapActions(["logout_cutehub"]),
  },
};
</script>

<style scoped lang="scss">
.profileImg {
  margin-bottom: 3rem;
  text-align: center;
  .mobiTitle {
    color: #fff;
  }
}
.userAccount__image {
  width: 92px;
  height: 92px;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 50%;
  img {
    width: 100%;
  }
}
.userAccount__name {
  p {
    color: #000;
  }
  margin-top: 15px;
}
.ar_layout {
  .userAccount__name .mobiTitle {
    text-align: center;
  }
  .inputWrap {
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cutehub/Profile.vue